export const validateTimeRange = values => {
    const errors = {};

    if (values.time_from && values.time_to && values.time_from.value >= values.time_to.value) {
        errors.time_from = 'Время начала не может быть больше времени окончания';
    }

    return errors;
};
